import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { KeyFilterPattern } from 'primeng/keyfilter';
import { EoBaseFormControlComponent } from '../eo-base-form-control/eo-base-form-control.component';
import { EoTextAreaConfig, IEoTextAreaConfig } from './eo-textarea.model';

@Component({
  selector: 'eo-textarea',
  templateUrl: './eo-textarea.component.html',
  styleUrls: ['./eo-textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoTextAreaComponent),
      multi: true,
    },
  ],
})
export class EoTextAreaComponent extends EoBaseFormControlComponent {
  protected override _config?: IEoTextAreaConfig;
  override get config(): EoTextAreaConfig | undefined {
    return this._config;
  }
  override set config(val: IEoTextAreaConfig | undefined) {
    this._config = val;
  }

  @Input() autoResize?: boolean;
  @Input() rows?: number;
  @Input() cols?: number;
  @Input() maxlength?: number;
  @Input() minlength?: number;
  @Input() placeholder?: string;
  @Input() readonly?: boolean;
  @Input() disabled?: boolean;
  @Input() resizable?: boolean;
  @Input() showClear?: boolean;
  @Input() inputStyleClass?: string;
  @Input() pKeyFilter?: RegExp | KeyFilterPattern | null;

  protected getAutoResize(): boolean {
    return this.autoResize ?? this.config?.autoResize ?? false;
  }

  protected getRows(): number {
    return this.rows ?? this.config?.rows ?? 2;
  }

  protected getCols(): number {
    return this.cols ?? this.config?.cols ?? 20;
  }

  protected getMaxlength(): number | null {
    return this.maxlength ?? this.config?.maxlength ?? null;
  }

  protected getMinlength(): number | null {
    return this.minlength ?? this.config?.minlength ?? null;
  }

  protected getPlaceholder(): string {
    return this.placeholder ?? this.config?.placeholder ?? '';
  }

  protected getReadonly(): boolean {
    return this.readonly ?? this.config?.readonly ?? false;
  }

  protected getDisabled(): boolean {
    return this.disabled ?? this.config?.disabled ?? false;
  }

  protected getResizable(): boolean {
    return this.resizable ?? this.config?.resizable ?? true;
  }

  protected getShowClear(): boolean {
    return this.showClear ?? this.config?.showClear ?? false;
  }

  protected clear() {
    this.getFormControl().setValue('');
  }

  protected getInputStyleClass(): string {
    return this.inputStyleClass ?? this.config?.inputStyleClass ?? '';
  }

  protected getPKeyFilter(): RegExp | KeyFilterPattern | null {
    return this.pKeyFilter ?? this.config?.pKeyFilter ?? null;
  }
}
